import { useTranslation } from "next-i18next";

import styles from "./SettingsSubscriptionContainer.module.scss";

export const DunningAlert = () => {
  const { t } = useTranslation("translations");

  return (
    <div className={`${styles.container} ${styles.dunning}`}>
      <div className={styles.status}>!</div>
      <div className={styles.text}>
        <div className="bold">
          {t("web_subscription_status_dunning_header")}
        </div>

        <span>{t("web_subscription_status_dunning_text")}</span>
      </div>
    </div>
  );
};

export default DunningAlert;
